/**
 * Generate a simple device fingerprint from user-agent and stored device ID
 * Used to recognize devices on future logins (client-side check)
 */

const DEVICE_ID_KEY = 'regure_device_id';
const REMEMBERED_EMAIL_KEY = 'regure_remembered_email';

/**
 * Get or create a unique device ID stored in localStorage
 */
export const getOrCreateDeviceId = () => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = `device_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};

/**
 * Get the remembered email from localStorage (if device was remembered)
 */
export const getRememberedEmail = () => {
  return localStorage.getItem(REMEMBERED_EMAIL_KEY) || '';
};

/**
 * Save email to localStorage when "Remember this device" is checked
 */
export const saveRememberedEmail = (email) => {
  if (email) {
    localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
  }
};

/**
 * Clear remembered email from localStorage (on logout)
 */
export const clearRememberedEmail = () => {
  localStorage.removeItem(REMEMBERED_EMAIL_KEY);
};

/**
 * Get simple user-agent based device name
 */
export const getDeviceName = () => {
  const ua = navigator.userAgent;
  if (ua.includes('Windows')) return 'Windows Device';
  if (ua.includes('Mac')) return 'Mac Device';
  if (ua.includes('Linux')) return 'Linux Device';
  if (ua.includes('iPhone')) return 'iPhone';
  if (ua.includes('iPad')) return 'iPad';
  if (ua.includes('Android')) return 'Android Device';
  return 'Unknown Device';
};
